"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || (function () {
    var ownKeys = function(o) {
        ownKeys = Object.getOwnPropertyNames || function (o) {
            var ar = [];
            for (var k in o) if (Object.prototype.hasOwnProperty.call(o, k)) ar[ar.length] = k;
            return ar;
        };
        return ownKeys(o);
    };
    return function (mod) {
        if (mod && mod.__esModule) return mod;
        var result = {};
        if (mod != null) for (var k = ownKeys(mod), i = 0; i < k.length; i++) if (k[i] !== "default") __createBinding(result, mod, k[i]);
        __setModuleDefault(result, mod);
        return result;
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
exports.getPipelineOpsBuildDetailOutputDtoSchema = exports.pipelineOpsAnalysisRecoverySchema = exports.aiAnalysisRecoveryBlockerSchema = exports.aiAnalysisRecoveryBudgetSchema = exports.pipelineOpsAnalysisRecoveryTargetSchema = exports.pipelineOpsNetlistGenerationFailureSchema = exports.pipelineOpsAnalysisBreakdownSchema = exports.pipelineOpsAnalysisSubjectSchema = exports.pipelineOpsSubjectConversationSchema = exports.pipelineOpsAnalysisStatusCountsSchema = exports.pipelineOpsSubjectStatusSchema = exports.pipelineOpsTimelineEntrySchema = exports.getPipelineOpsBuildDetailInputDtoSchema = exports.getPipelineOpsSnapshotOutputDtoSchema = exports.pipelineOpsStageClocksSchema = exports.pipelineOpsFastModeCountsSchema = exports.pipelineOpsStageCountSchema = exports.pipelineOpsBuildRowSchema = exports.pipelineOpsBomMergeSchema = exports.pipelineOpsDeliveryHealthSchema = exports.pipelineOpsAnalysisRollupSchema = exports.pipelineOpsBomProgressSchema = exports.pipelineOpsPhaseCompletionSchema = exports.pipelineOpsStageStatusSchema = exports.pipelineOpsOrganizationSchema = exports.pipelineOpsUnlistedRunSchema = exports.pipelineOpsRunSchema = exports.pipelineOpsExclusionCountSchema = exports.pipelineOpsFilterSchema = exports.getPipelineOpsSnapshotInputDtoSchema = void 0;
const z = __importStar(require("zod"));
const cadstrom_shared_1 = require("@cadstrom/cadstrom-shared");
const remediation_dto_js_1 = require("./remediation.dto.js");
exports.getPipelineOpsSnapshotInputDtoSchema = z.object({
    windowDays: z.number().int().min(1).max(cadstrom_shared_1.PIPELINE_OPS_MAX_WINDOW_DAYS).default(cadstrom_shared_1.PIPELINE_OPS_DEFAULT_WINDOW_DAYS),
    organizationId: z.string().min(1).optional(),
    includeInternalOrgs: z.boolean().optional(),
    includeSuperseded: z.boolean().optional(),
    includeDormant: z.boolean().optional(),
    includeDelivered: z.boolean().optional(),
});
exports.pipelineOpsFilterSchema = z.object({
    windowDays: z.number().int(),
    organizationId: z.string().optional(),
    includeInternalOrgs: z.boolean(),
    includeSuperseded: z.boolean(),
    includeDormant: z.boolean(),
    includeDelivered: z.boolean(),
});
exports.pipelineOpsExclusionCountSchema = z.object({
    reason: z.nativeEnum(cadstrom_shared_1.PipelineOpsExclusion),
    count: z.number().int(),
});
exports.pipelineOpsRunSchema = z.object({
    workflowId: z.string(),
    runId: z.string(),
    workflowType: z.string(),
    status: z.nativeEnum(cadstrom_shared_1.PipelineWorkflowStatus),
    startedAt: z.date().optional(),
    closedAt: z.date().optional(),
    stage: z.string().optional(),
});
exports.pipelineOpsUnlistedRunSchema = z.object({
    workflowId: z.string(),
    reason: z.nativeEnum(cadstrom_shared_1.PipelineOpsUnlistedReason),
    buildId: z.string().optional(),
    projectName: z.string().optional(),
    organizationName: z.string().optional(),
    buildNumber: z.number().int().optional(),
    startedAt: z.date().optional(),
});
exports.pipelineOpsOrganizationSchema = z.object({
    organizationId: z.string(),
    organizationName: z.string(),
    isInternal: z.boolean(),
    buildCount: z.number().int(),
});
exports.pipelineOpsStageStatusSchema = z.object({
    stage: z.nativeEnum(cadstrom_shared_1.PipelineStage),
    state: z.nativeEnum(cadstrom_shared_1.PipelineStageState),
});
exports.pipelineOpsPhaseCompletionSchema = z.object({
    phase: z.nativeEnum(cadstrom_shared_1.PipelinePhase),
    completedAt: z.date(),
    durationMs: z.number().optional(),
});
exports.pipelineOpsBomProgressSchema = z.object({
    modules: z.number().int(),
    dispatchedModules: z.number().int(),
    resolvedModules: z.number().int(),
});
exports.pipelineOpsAnalysisRollupSchema = z.object({
    triggersRun: z.number().int(),
    entriesTotal: z.number().int(),
    entriesProcessed: z.number().int(),
    entriesRunning: z.number().int(),
    entriesFailed: z.number().int(),
    entriesFilteredOut: z.number().int(),
    lastUpdatedAt: z.date().optional(),
});
exports.pipelineOpsDeliveryHealthSchema = z.object({
    slaJudgment: z.nativeEnum(cadstrom_shared_1.DeliverySlaJudgment),
    slaBusinessDays: z.number().int(),
    slaSource: z.nativeEnum(cadstrom_shared_1.DeliverySlaSource),
    grossBusinessDays: z.number().optional(),
    netBusinessDays: z.number().optional(),
    inCustomerCourt: z.boolean(),
    funnelY: z.number().int(),
    funnelProcessed: z.number().int(),
    funnelOperator: z.number().int(),
    funnelException: z.number().int(),
    funnelPublished: z.number().int(),
    funnelFailed: z.number().int(),
    funnelGate: z.nativeEnum(cadstrom_shared_1.DeliveryFunnelGate),
    healthReason: z.nativeEnum(cadstrom_shared_1.DeliveryHealthReason),
    whyText: z.string(),
    computedAt: z.date(),
});
exports.pipelineOpsBomMergeSchema = z.object({
    status: z.nativeEnum(cadstrom_shared_1.PipelineWorkflowStatus).optional(),
    closedAt: z.date().optional(),
});
exports.pipelineOpsBuildRowSchema = z.object({
    buildId: z.string(),
    buildNumber: z.number().int(),
    projectId: z.string(),
    projectName: z.string(),
    organizationId: z.string(),
    organizationName: z.string(),
    status: z.nativeEnum(cadstrom_shared_1.BuildStatus),
    statusMessage: z.string().optional(),
    automationMode: z.nativeEnum(cadstrom_shared_1.BuildAutomationMode),
    createdAt: z.date(),
    acceptedAt: z.date().optional(),
    enteredStatusAt: z.date(),
    hoursInStatus: z.number(),
    totalHours: z.number(),
    hoursInReview: z.number().optional(),
    stages: exports.pipelineOpsStageStatusSchema.array(),
    diedInStatus: z.nativeEnum(cadstrom_shared_1.BuildStatus).optional(),
    awaiting: z.nativeEnum(cadstrom_shared_1.PipelineAwaitingState),
    netlistFailure: z.nativeEnum(cadstrom_shared_1.PipelineNetlistFailure).optional(),
    netlistGate: z.nativeEnum(cadstrom_shared_1.NetlistGateState).optional(),
    workflowStage: z.string().optional(),
    workflowStatus: z.nativeEnum(cadstrom_shared_1.PipelineWorkflowStatus).optional(),
    workflowStartedAt: z.date().optional(),
    workflowClosedAt: z.date().optional(),
    bomMerge: exports.pipelineOpsBomMergeSchema.optional(),
    analysisRunning: z.boolean().optional(),
    superseded: z.boolean(),
    phases: exports.pipelineOpsPhaseCompletionSchema.array(),
    demotionReason: z.string().optional(),
    demotedAt: z.date().optional(),
    analysis: exports.pipelineOpsAnalysisRollupSchema,
    heartbeat: z.number().int().array(),
    workflowId: z.string(),
    delivery: exports.pipelineOpsDeliveryHealthSchema.optional(),
});
exports.pipelineOpsStageCountSchema = z.object({
    status: z.nativeEnum(cadstrom_shared_1.BuildStatus),
    count: z.number().int(),
});
exports.pipelineOpsFastModeCountsSchema = z.object({
    automatic: z.number().int(),
    manual: z.number().int(),
    demoted: z.number().int(),
});
const stageClockHoursValueSchema = z.number().nullable();
exports.pipelineOpsStageClocksSchema = z.object({
    [cadstrom_shared_1.PipelineStage.Upload]: stageClockHoursValueSchema,
    [cadstrom_shared_1.PipelineStage.Validate]: stageClockHoursValueSchema,
    [cadstrom_shared_1.PipelineStage.Resolve]: stageClockHoursValueSchema,
    [cadstrom_shared_1.PipelineStage.BomReview]: stageClockHoursValueSchema,
    [cadstrom_shared_1.PipelineStage.Merge]: stageClockHoursValueSchema,
    [cadstrom_shared_1.PipelineStage.Netlist]: stageClockHoursValueSchema,
    [cadstrom_shared_1.PipelineStage.AnalysisGate]: stageClockHoursValueSchema,
    [cadstrom_shared_1.PipelineStage.Analysis]: stageClockHoursValueSchema,
    [cadstrom_shared_1.PipelineStage.Review]: stageClockHoursValueSchema,
    [cadstrom_shared_1.PipelineStage.Deliver]: stageClockHoursValueSchema,
});
exports.getPipelineOpsSnapshotOutputDtoSchema = z.object({
    computedAt: z.date(),
    readModelComputedAt: z.date().optional(),
    windowDays: z.number().int(),
    filter: exports.pipelineOpsFilterSchema,
    excluded: exports.pipelineOpsExclusionCountSchema.array(),
    organizations: exports.pipelineOpsOrganizationSchema.array(),
    unlistedRuns: exports.pipelineOpsUnlistedRunSchema.array(),
    activeBuilds: z.number().int(),
    truncated: z.boolean(),
    stageCounts: exports.pipelineOpsStageCountSchema.array(),
    fastMode: exports.pipelineOpsFastModeCountsSchema,
    stageClocks: exports.pipelineOpsStageClocksSchema,
    builds: exports.pipelineOpsBuildRowSchema.array(),
});
exports.getPipelineOpsBuildDetailInputDtoSchema = z.object({
    buildId: z.string().min(1),
});
exports.pipelineOpsTimelineEntrySchema = z.object({
    eventId: z.string(),
    eventType: z.string(),
    fromStatus: z.string().optional(),
    toStatus: z.string().optional(),
    occurredAt: z.date(),
    actor: z.string(),
    reason: z.string().optional(),
    payload: cadstrom_shared_1.JsonValueSchema,
});
exports.pipelineOpsSubjectStatusSchema = z.enum(['queued', 'processing', 'processed', 'filtered_out', 'failed']);
exports.pipelineOpsAnalysisStatusCountsSchema = z.object({
    queued: z.number().int(),
    processing: z.number().int(),
    processed: z.number().int(),
    filtered_out: z.number().int(),
    failed: z.number().int(),
});
exports.pipelineOpsSubjectConversationSchema = z.object({
    conversationId: z.string(),
    taskKey: z.string().optional(),
    ownerId: z.string().optional(),
});
exports.pipelineOpsAnalysisSubjectSchema = z.object({
    subjectKey: z.string(),
    status: exports.pipelineOpsSubjectStatusSchema,
    stranded: z.boolean(),
    attempts: z.number().int(),
    updatedAt: z.date(),
    runs: z.number().int(),
    failedRuns: z.number().int(),
    conversations: exports.pipelineOpsSubjectConversationSchema.array(),
});
exports.pipelineOpsAnalysisBreakdownSchema = z.object({
    triggerId: z.string(),
    subjectType: z.string(),
    statusCounts: exports.pipelineOpsAnalysisStatusCountsSchema,
    stranded: z.number().int(),
    attemptsMax: z.number().int(),
    lastUpdatedAt: z.date(),
    recentErrors: z.string().array(),
    subjects: exports.pipelineOpsAnalysisSubjectSchema.array(),
});
exports.pipelineOpsNetlistGenerationFailureSchema = z.object({
    status: z.nativeEnum(cadstrom_shared_1.PipelineWorkflowStatus),
    message: z.string(),
    closedAt: z.date().optional(),
    code: z.nativeEnum(cadstrom_shared_1.NetlistGenerationFailureCode).optional(),
    remediation: remediation_dto_js_1.remediationSchema,
});
exports.pipelineOpsAnalysisRecoveryTargetSchema = z.object({
    triggerId: z.string(),
    failed: z.number().int(),
    stranded: z.number().int(),
    live: z.number().int(),
    queued: z.number().int(),
    attemptsMax: z.number().int(),
    liveLeaseExpiresAt: z.date().optional(),
});
exports.aiAnalysisRecoveryBudgetSchema = z.object({
    maxResumeAttempts: z.number().int(),
    maxFreshRetries: z.number().int(),
    totalAttempts: z.number().int(),
});
exports.aiAnalysisRecoveryBlockerSchema = z.object({
    kind: z.nativeEnum(cadstrom_shared_1.AiAnalysisRecoveryBlockerKind),
    triggerId: z.string().optional(),
    until: z.date().optional(),
    workflowId: z.string().optional(),
});
exports.pipelineOpsAnalysisRecoverySchema = z.object({
    analysisRunId: z.string(),
    mode: z.nativeEnum(cadstrom_shared_1.AiAnalysisRecoveryMode),
    demotionReason: z.string().optional(),
    targets: exports.pipelineOpsAnalysisRecoveryTargetSchema.array(),
    attemptsUsed: z.number().int(),
    budget: exports.aiAnalysisRecoveryBudgetSchema,
    blockers: exports.aiAnalysisRecoveryBlockerSchema.array(),
});
exports.getPipelineOpsBuildDetailOutputDtoSchema = z.object({
    buildId: z.string(),
    timeline: exports.pipelineOpsTimelineEntrySchema.array(),
    timelineTruncated: z.boolean(),
    bom: exports.pipelineOpsBomProgressSchema,
    analysis: exports.pipelineOpsAnalysisBreakdownSchema.array(),
    analysisSubjectsTruncated: z.boolean(),
    analysisRecovery: exports.pipelineOpsAnalysisRecoverySchema.optional(),
    workflowId: z.string(),
    runs: exports.pipelineOpsRunSchema.array(),
    runsTruncated: z.boolean(),
    netlistGenerationFailure: exports.pipelineOpsNetlistGenerationFailureSchema.optional(),
});
//# sourceMappingURL=pipeline-ops.dto.js.map